module.exports = __webpack_public_path__ + "media/images/cart/cart_btn03_ov-2b69f78b01b338c06d8d6a78c90ad9ae.gif";